
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/page/create",
      function () {
        return require("private-next-pages/page/create.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/page/create"])
      });
    }
  